// extracted by mini-css-extract-plugin
export default {"tooltip-wrapper":"styles_tooltip-wrapper__nD5JA","tooltip-content":"styles_tooltip-content__HyLiJ"};